module.exports = __webpack_public_path__ + "img/renofloor.806faf7b.jpg";